var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificacionesLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_775_1305)",
    fillOpacity: 0.2,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0294 20.49L25.0294 18.83C24.8194 18.46 24.6294 17.76 24.6294 17.35V14.82C24.6294 12.47 23.2494 10.44 21.2594 9.49C20.7394 8.57 19.7794 8 18.6794 8C17.5894 8 16.6094 8.59 16.0894 9.52C14.1394 10.49 12.7894 12.5 12.7894 14.82V17.35C12.7894 17.76 12.5994 18.46 12.3894 18.82L11.3794 20.49C10.9794 21.16 10.8894 21.9 11.1394 22.58C11.3794 23.25 11.9494 23.77 12.6894 24.02C14.6294 24.68 16.6694 25 18.7094 25C20.7494 25 22.7894 24.68 24.7294 24.03C25.4294 23.8 25.9694 23.27 26.2294 22.58C26.4894 21.89 26.4194 21.13 26.0294 20.49Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5191 26.01C21.0991 27.17 19.9891 28 18.6891 28C17.8991 28 17.1191 27.68 16.5691 27.11C16.2491 26.81 16.0091 26.41 15.8691 26C15.9991 26.02 16.1291 26.03 16.2691 26.05C16.4991 26.08 16.7391 26.11 16.9791 26.13C17.5491 26.18 18.1291 26.21 18.7091 26.21C19.2791 26.21 19.8491 26.18 20.4091 26.13C20.6191 26.11 20.8291 26.1 21.0291 26.07C21.1891 26.05 21.3491 26.03 21.5191 26.01Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_775_1305",
    x1: 18.5,
    y1: 0,
    x2: 18.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB520"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacionesLight);
export default __webpack_public_path__ + "static/media/Notificaciones-light.de6452a820e16b9779db21e214e26391.svg";
export { ForwardRef as ReactComponent };